import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function StickyCta() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 lg:hidden" data-testid="sticky-mobile-cta">
      <div className="grid grid-cols-2 gap-px border-t border-girder bg-girder">
        <Link
          to="/products"
          data-testid="sticky-cta-shop"
          className="flex items-center justify-center bg-hivis py-4 font-display text-base font-bold uppercase tracking-wide text-obsidian transition-colors active:bg-hivis-hover"
        >
          Shop the Kits
        </Link>
        <Link
          to="/dealer-portal"
          data-testid="sticky-cta-dealer"
          className="flex items-center justify-center gap-2 bg-obsidian py-4 font-display text-base font-bold uppercase tracking-wide text-slate-200 transition-colors active:text-hivis"
        >
          <Lock className="h-4 w-4 text-hivis" /> Dealer Pricing
        </Link>
      </div>
    </div>
  );
}
